(() => {
	const ADD_TO_CART_TEXT = window?.variantStrings?.addToCart || 'Add to cart';

	function hasVariantParam() {
		return new URLSearchParams(window.location.search).has('variant');
	}

	function setAddToCartEnabled(productInfo, enabled) {
		const productForm = productInfo?.querySelector('product-form');
		if (!productForm || typeof productForm.toggleSubmitButton !== 'function') return;

		if (enabled) {
			productForm.toggleSubmitButton(false);
			const submit = productForm.querySelector('[type="submit"]');
			const label = submit?.querySelector('span');
			if (label) label.textContent = ADD_TO_CART_TEXT;
			return;
		}

		productForm.toggleSubmitButton(true);
	}

	function setupProductFlow(productInfo) {
		let secondOptionSelectedByUser = false;
		let previousFirstOptionValue = null;
		let shouldClearSecondAfterVariantUpdate = false;
		let variantChangeUnsubscriber = null;

		const clearChecked = (inputs) => {
			inputs.forEach((input) => {
				input.checked = false;
			});
		};

		const getVariantContext = () => {
			const variantSelects = productInfo.querySelector('variant-selects');
			if (!variantSelects) return null;

			const optionOneFieldset = variantSelects.querySelector('.custom-variant-button-outer.option-position-1');
			const optionTwoFieldset = variantSelects.querySelector('.custom-variant-button-outer.option-position-2');
			if (!optionOneFieldset || !optionTwoFieldset) return null;

			const optionOneInputs = Array.from(optionOneFieldset.querySelectorAll('input[type="radio"]'));
			const optionTwoInputs = Array.from(optionTwoFieldset.querySelectorAll('input[type="radio"]'));
			const customFields = productInfo.querySelector('.product-custom-fields');

			return {
				optionOneFieldset,
				optionTwoFieldset,
				optionOneInputs,
				optionTwoInputs,
				customFields,
			};
		};

		const isOptionSelected = (inputs) => inputs.some((input) => input.checked);

		const getCheckedValue = (inputs) => {
			const checkedInput = inputs.find((input) => input.checked);
			return checkedInput ? checkedInput.value : null;
		};

		const applyUiState = () => {
			const context = getVariantContext();
			if (!context) return;

			const {
				optionOneFieldset,
				optionTwoFieldset,
				optionOneInputs,
				optionTwoInputs,
				customFields,
			} = context;

			const firstSelected = isOptionSelected(optionOneInputs);
			const firstOptionValue = getCheckedValue(optionOneInputs);

			if (firstOptionValue !== previousFirstOptionValue) {
				secondOptionSelectedByUser = false;
				clearChecked(optionTwoInputs);
			}
			previousFirstOptionValue = firstOptionValue;

			optionTwoFieldset.style.display = firstSelected ? '' : 'none';

			if (!firstSelected) {
				secondOptionSelectedByUser = false;
				clearChecked(optionTwoInputs);
			}

			if (firstSelected && !secondOptionSelectedByUser) {
				clearChecked(optionTwoInputs);
			}

			const secondNowSelected = isOptionSelected(optionTwoInputs);

			if (customFields) {
				customFields.style.display = firstSelected && secondNowSelected && secondOptionSelectedByUser ? '' : 'none';
			}

			setAddToCartEnabled(productInfo, firstSelected && secondNowSelected && secondOptionSelectedByUser);
		};

		const clearSecondOptionAfterVariantUpdate = () => {
			const context = getVariantContext();
			if (!context) return;

			clearChecked(context.optionTwoInputs);
			secondOptionSelectedByUser = false;
			applyUiState();
		};

		if (!hasVariantParam()) {
			const context = getVariantContext();
			if (context) {
				clearChecked(context.optionOneInputs);
				clearChecked(context.optionTwoInputs);
			}
			secondOptionSelectedByUser = false;
			previousFirstOptionValue = null;
			setAddToCartEnabled(productInfo, false);
		}

		applyUiState();

		productInfo.addEventListener('change', (event) => {
			const target = event.target;
			if (!(target instanceof HTMLElement)) return;

			const variantRoot = target.closest('variant-selects');
			if (!variantRoot) return;

			const secondOptionInput = target.closest('.custom-variant-button-outer.option-position-2 input[type="radio"]');
			if (secondOptionInput && secondOptionInput.checked) {
				secondOptionSelectedByUser = true;
			}

			const firstOptionInput = target.closest('.custom-variant-button-outer.option-position-1 input[type="radio"]');
			if (firstOptionInput) {
				secondOptionSelectedByUser = false;
				shouldClearSecondAfterVariantUpdate = true;
			}

			applyUiState();
		});

		if (typeof subscribe === 'function' && window?.PUB_SUB_EVENTS?.variantChange) {
			variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
				if (!shouldClearSecondAfterVariantUpdate) return;

				const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
				if (data?.sectionId && sectionId && data.sectionId !== sectionId) return;

				requestAnimationFrame(() => {
					clearSecondOptionAfterVariantUpdate();
					shouldClearSecondAfterVariantUpdate = false;
				});
			});
		}

		const observer = new MutationObserver(() => {
			if (!shouldClearSecondAfterVariantUpdate) return;
			clearSecondOptionAfterVariantUpdate();
			shouldClearSecondAfterVariantUpdate = false;
		});

		observer.observe(productInfo, { childList: true, subtree: true });

		productInfo.addEventListener('product-info:loaded', () => {
			if (!shouldClearSecondAfterVariantUpdate) return;
			clearSecondOptionAfterVariantUpdate();
			shouldClearSecondAfterVariantUpdate = false;
		});

		productInfo.addEventListener('remove', () => {
			observer.disconnect();
			variantChangeUnsubscriber?.();
		});
	}

	function init() {
		const mainProduct = document.querySelector('product-info[id^="MainProduct-"]');
		if (!mainProduct) return;
		setupProductFlow(mainProduct);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();
